/**
 * Live feedback, computed from the regions and the marks alone (CLAUDE.md §10): the answer key
 * never reaches this code. Only what can no longer be right is flagged.
 */
import type { Feedback } from "../types";
import { resizeRows } from "./progress";
import { contradictions, lines } from "./rules";
import { cellId, type StarBattleDefinition, type StarBattleProgress } from "./types";

export function localFeedback(
  definition: StarBattleDefinition,
  progress: StarBattleProgress,
): Feedback[] {
  const marks = resizeRows(progress.rows, definition.size);
  const found = contradictions(definition.regions, definition.stars, marks);
  const cellsOf = new Map(lines(definition.regions, definition.size).map((l) => [l.id, l.cells]));
  const feedback: Feedback[] = found.lines.map((id) => {
    const [type, index] = id.split(":");
    return {
      type,
      code: "star_count_contradiction",
      index: type === "region" ? null : Number(index),
      scope: type === "region" ? index : undefined,
      cells: (cellsOf.get(id) ?? []).map(([r, c]) => cellId(r, c)),
    };
  });
  if (found.touching.length > 0)
    feedback.push({
      type: "star",
      code: "stars_touch",
      cells: found.touching.map(([r, c]) => cellId(r, c)),
    });
  return feedback;
}
